/**
 * @typedef { import('../../time.js').YearMonthPeriod } YearMonthPeriod
 * @typedef { import('../../time.js').YearMonthPeriodObject } YearMonthPeriodObject
 * @typedef { import('../../time.js').YearMonth } YearMonth
 */

import {Report     } from './retention_report.js';
import {Cohort     } from './retention_report.js';
import {MonthMetric} from './retention_report.js';

import {parseYearMonth                } from '../../time.js';
import {convertObjectToYearMonthPeriod} from '../../time.js';

 /**
  * @typedef {Object} ReportObject
  * @property {YearMonthPeriodObject} period
  * @property {?CohortObject[]} cohorts
  */
 
 /**
  * @param {ReportObject} reportObject 
  * @returns {?Report}
  */
export function convertObjectToRetentionReport(reportObject) {
    const period = convertObjectToYearMonthPeriod(reportObject.period);
    if(period === null) {
      return null;
    }

    const cohortObjects = reportObject.cohorts;
    let cohorts = null;

    if(cohortObjects !== null) {
      const parsedCohorts = convertArrayToCohorts(cohortObjects);
      if(parsedCohorts === null) {
        return null; // parsing error
      }
      cohorts = parsedCohorts;
    }

    return new Report(period, cohorts);
}

//-----------------------------------------------------------------------------

/**
 * @typedef {Object} CohortObject
 * @property {string} month
 * @property {number} size
 * @property {?MonthMetricObject[]} metrics
 */

/**
 * @param {CohortObject[]} cohortObjects
 * @returns {?Cohort[]}
 */
function convertArrayToCohorts(cohortObjects) {
  const cohorts = [];

  for(const cohortObj of cohortObjects) {
    const cohort = convertObjectToCohort(cohortObj);
    if(cohort === null) {
        return null;
    }
    cohorts.push(cohort);
  }

  return cohorts;
}

/**
 * @param {CohortObject} cohortObj
 * @returns {?Cohort}
 */
function convertObjectToCohort(cohortObj) {
  const ym = parseYearMonth(cohortObj.month);
  if(ym === null) {
    return null;
  }

  let metrics = null;
  if(cohortObj.metrics !== null) {
      const metricsTmp = convertArrayToMetrics(cohortObj.metrics);
      if(metricsTmp === null) {
        return null; // parsing error
      }
      metrics = metricsTmp;
  }

  return new Cohort(ym, cohortObj.size, metrics);
}

//-----------------------------------------------------------------------------

/**
 * @typedef {Object} MonthMetricObject
 * @property {string} month
 * @property {number} value
 */

/**
 * @param {MonthMetricObject[]} metricObjects
 * @returns {?MonthMetric[]}
 */
function convertArrayToMetrics(metricObjects) {
  const metrics = [];

  for(const metricObject of metricObjects) {
    const metric = convertObjectToMetric(metricObject);
    if(metric === null) {
        return null;
    }
    metrics.push(metric);
  }

  return metrics;
}

/**
 * @param {MonthMetricObject} metricObject 
 * @returns {?MonthMetric}
 */
function convertObjectToMetric(metricObject) {
  const ym = parseYearMonth(metricObject.month);
  if(ym === null) {
    return null;
  }

  return new MonthMetric(ym, metricObject.value);
}
